module.exports = __webpack_public_path__ + "img/logo.f886a2d3.png";